import { Button, Tooltip, message } from 'antd'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { findAndSetProxy } from '../../../Reducers/accounts';

const SetProxyButton = ({ record, afterUpdate, title, icon }) => {

  const dispatch = useDispatch();

  const { id } = record;

  const setProxyForUser = useCallback(() => {
    dispatch(findAndSetProxy(id)).then((proxy) => {
        if (proxy && proxy.host) {
          message.success(`Proxy changed: ${proxy.host}:${proxy.port} (id ${proxy.id})`);
        } else {
          message.warning('No other free proxy in account group — proxy not changed');
        }
        afterUpdate();
    }).catch(error => {
        console.log(error);
        message.error('Can\'t set worker proxy');
    })
}, [dispatch, afterUpdate, id]);
  


  return (
    <>
      <Tooltip placement="topLeft" title={title}>
        <Button
          icon={icon}
          onClick={setProxyForUser}
        />
      </Tooltip>
    </>
  )
}

export default SetProxyButton
